import type { RouterOutputs } from "~/utils/api";

type SpheresRes = RouterOutputs["scores"]["spheres"];

interface InnerCircle {
  domain: string;
  slice: number;
  fill: string;
}

export const normalizeMentalBalanceSpheres = <T extends InnerCircle>(
  data: SpheresRes,
  InnerCircle: T[],
) => {
  return InnerCircle.reduce<
    {
      domain: string;
      slice: number;
      fill: string;
      value: number;
    }[]
  >((acc, cur) => {
    const score = data?.data.find(
      (sphere) => sphere.domain === cur.domain,
    )?.score;

    acc?.push({
      ...cur,
      value: score ?? 0,
    });

    return acc;
  }, []);
};
